import store from "@/store";

const handler = (event, data) => {
  switch (event) {
    case "dns-zone:update":
    case "dns-zone:delete":
      store.dispatch("dnsZones/refreshList");
      break;
    case "dns-record:add":
    case "dns-record:update":
      if (data.type === "A" || data.type === "AAAA") {
        store.dispatch("dnsZoneARecords/refreshList", data.zone_id);
      }
      if (data.type === "CAA") {
        store.dispatch("dnsZoneCaaRecords/refreshList", data.zone_id);
      }
      if (data.type === "CNAME") {
        store.dispatch("dnsZoneCnameRecords/refreshList", data.zone_id);
      }
      if (data.type === "MX") {
        store.dispatch("dnsZoneMxRecords/refreshList", data.zone_id);
      }
      if (data.type === "NS") {
        store.dispatch("dnsZoneNsRecords/refreshList", data.zone_id);
      }
      if (data.type === "PTR") {
        store.dispatch("rdnsRecords/refreshList");
      }
      if (data.type === "SPF") {
        store.dispatch("dnsZoneSpfRecords/refreshList", data.zone_id);
      }
      if (data.type === "SRV") {
        store.dispatch("dnsZoneSrvRecords/refreshList", data.zone_id);
      }
      if (data.type === "TXT") {
        store.dispatch("dnsZoneTxtRecords/refreshList", data.zone_id);
      }
      break;
    case "dns-record:delete":
      store.dispatch("dnsZoneARecords/refreshListByRecordId", data.id);
      store.dispatch("dnsZoneCaaRecords/refreshListByRecordId", data.id);
      store.dispatch("dnsZoneCnameRecords/refreshListByRecordId", data.id);
      store.dispatch("dnsZoneMxRecords/refreshListByRecordId", data.id);
      store.dispatch("dnsZoneNsRecords/refreshListByRecordId", data.id);
      store.dispatch("dnsZoneSpfRecords/refreshListByRecordId", data.id);
      store.dispatch("dnsZoneSrvRecords/refreshListByRecordId", data.id);
      store.dispatch("dnsZoneTxtRecords/refreshListByRecordId", data.id);
      if (data.type === "PTR") {
        store.dispatch("rdnsRecords/refreshList");
      }
      break;
  }
};

export default handler;
